import { db, auth } from "../firebase/firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export type LogCategory = "auth" | "actions" | "users" | "activity";
export type LogStatus = "success" | "warning" | "error" | "info";

export interface LogData {
  type: "AUTH" | "ACTIVITY" | "USER" | "SYSTEM" | "ERROR";
  user: string;
  email: string | null;
  userId?: string; // Optional, will default to current auth user
  action: string;
  details: string;
  status: LogStatus;
  time?: string;
}

/**
 * Utility to log events to Firestore in a scalable way (separate documents).
 */
export const logToSystem = async (
  orgId: string,
  category: LogCategory,
  logData: LogData
) => {
  if (!orgId) return;

  const now = new Date();
  const timeString = now.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ', ' + now.toLocaleTimeString('en-US', { hour12: false });

  const finalLog = {
    ...logData,
    userId: logData.userId || auth.currentUser?.uid || "unknown",
    time: logData.time || timeString,
    timestamp: serverTimestamp(),
  };

  try {
    // Path structure: organization/ID/SystemLogs/category/userId
    // 1: organization (coll), 2: orgId (doc), 3: SystemLogs (coll), 4: category (doc), 5: userId (coll)
    const userId = logData.userId || auth.currentUser?.uid || "unknown";
    const logsRef = collection(db, "organization", orgId, "SystemLogs", category, userId);
    await addDoc(logsRef, {
      ...finalLog,
      userId // Also keep it as a field for easier filtering if needed
    });
  } catch (error) {
    console.error(`Error logging to ${category}:`, error);
  }
};
